import { Stack } from "@certn/cascadia/foundations/grid-layout/Stack";
import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  ListBoxItem as AriaListBoxItem,
  ListBoxItemProps,
} from "react-aria-components";

import { Icon } from "../../../../foundations/icons/Icon/Icon";

import { getTextStyle } from "../../../../foundations/typography/styles";

interface Props extends ListBoxItemProps {}

export function _ListBoxItem(props: Props) {
  const {
    textValue = typeof props.children === "string" ? props.children : undefined,
  } = props;

  return (
    <AriaListBoxItem
      {...mergeProps(props, {
        className: cx("react-aria-ListBoxItem", styles.component),
      })}
      textValue={textValue}
    >
      {(renderProps) => {
        return (
          <>
            {typeof props.children === "function"
              ? props.children(renderProps)
              : props.children}

            {renderProps.isSelected && (
              <Stack align="end" className={styles.check}>
                <Icon name="check" color="icon-weak" />
              </Stack>
            )}
          </>
        );
      }}
    </AriaListBoxItem>
  );
}

const styles = {
  check: css({
    flex: 1,
  }),
  component: css(
    {
      paddingTop: "var(--space-2)",
      paddingBottom: "var(--space-2)",
      paddingLeft: "var(--space-3)",
      paddingRight: "var(--space-3)",
      borderRadius: "var(--border-radius-2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "var(--space-3)",
      outline: "none",
      "&[data-selected]": {
        backgroundColor: "var(--background-selected-weak)",
      },
      "&[data-hovered], &[data-focus-visible]": {
        backgroundColor: "var(--background-ghost-hover)",
      },
      "&[data-disabled]": {
        cursor: "not-allowed",
        color: "var(--text-disabled)",
      },
    },
    getTextStyle("input/text-field")
  ),
};
